import request, { FormDataHeader } from '@/utils/request'
import {
  ReceiveRewardParams,
  BindInvitationCodeParams,
  RecommendCountData,
  ClaimItem,
  BindingItem,
  RewardItem,
  UserInfoData,
  ActivityInfoData,
} from '@/types/old-brings-new'

/**
 * 领取奖品
 */
export function receiveReward(params: ReceiveRewardParams): Promise<void> {
  return request.post('/api-new-crm/app/referral_reward/receive_reward', params)
}

/**
 * 绑定邀请码
 */
export function bindInvitationCode(params: BindInvitationCodeParams): Promise<void> {
  return request.post('/api-new-crm/app/referral_reward/bind_invitation_code', params)
}

/**
 * 获取推荐数量
 */
export function getRecommendCount(): Promise<RecommendCountData> {
  return request.get('/api-new-crm/app/referral_reward/recommend_count')
}

/**
 * 奖品领取记录
 */
export function getClaimsList(): Promise<ClaimItem[]> {
  return request.get('/api-new-crm/app/referral_reward/claims_list')
}

/**
 * 邀请记录
 */
export function getBindingsList(): Promise<BindingItem[]> {
  return request.get('/api-new-crm/app/referral_reward/bindings_list')
}

/**
 * 奖励配置列表
 */
export function getRewardList(): Promise<RewardItem[]> {
  return request.get('/api-new-crm/app/referral_reward/reward_list')
}

/**
 * 获取用户信息
 */
export function getActivityUserInfo(): Promise<UserInfoData> {
  return request.get('/api-new-crm/app/referral_reward/user_info')
}

/**
 * 获取生效的活动信息
 */
export function getActivityInfo(): Promise<ActivityInfoData> {
  return request.get('/api-new-crm/app/referral_reward/activity_info')
}
